import Masonry from 'masonry-layout/masonry';

export function adaptPackImg(container) {
    let files = container.querySelectorAll('.widereview-thumbnail img');
    files.forEach(function (img) {
        img.height =  img.getAttribute('original-height') / img.getAttribute('original-width') * img.width;
    })
};

function displayPackHiddenReviews(number, btn) {
    let count = 10 * number;
    let reviews = document.querySelectorAll('.widereview-pack-review-wrapper');
    for (let i = 0; i < count; i++) {
        if (reviews.length < (i+1)) {
            if (btn) {
                btn.remove();
            }
            break;
        }
        reviews[i].style.display = 'block';
    }
}

export function watchEventPackHiddenReviews (reviews, options) {
    let number = 1;
    let container = document.querySelector('.widereview-content--pack');
    if (!container) return;
    const btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    btn.className = "widereview-btn-more-text";
    btn.innerHTML = options.add_button_more_text;

    if (reviews.length > 10 ) {
        container.append(btn);

        btn.onclick = function (evt) {
            evt.preventDefault();
            number ++;
            displayPackHiddenReviews(number, btn);
            initMasonry();
        }
    }

    displayPackHiddenReviews(number, btn);
}

export function initMasonry () {
    const widereviewMasonry = new Masonry('.widereview-content--pack', {
        // options
        itemSelector: '.widereview-pack-review-wrapper',
        gutter: 12,
        percentPosition: true,
        columnWidth: '.widereview-pack-review-wrapper',
        // columnWidth: 290
    });
};
